import { RenderReportItem } from './RenderReportItem'
import React from 'react'

export const RenderStatusReport = (props) => {
  const { status, title, isTotal } = props
  const colors = {
    active: '#67b633',
    idle: '#fdc602',
    archived: '#999',
    total: '#673AB7',
  }

  const numActive = status.active?.length || 0
  const numIdle = status.idle?.length || 0
  const numArchived = status.archived?.length || 0
  const totalCount = numActive + numIdle + numArchived

  return (
    <div
      className="wb-card wb-card--smoke wb-type-copy wb-padding-xs"
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      {title && <h3 style={{ flex: 1 }}>{title}</h3>}
      <div className="wb-padding-top-xxs">
        <RenderReportItem
          title="Active"
          num={numActive}
          color={colors.active}
        />
        <RenderReportItem title="Idle" num={numIdle} color={colors.idle} />
        <RenderReportItem
          title="Archived"
          num={numArchived}
          color={colors.archived}
        />
        <>
          <hr />
          <RenderReportItem
            title="Total Booked"
            num={totalCount}
            color={colors.total}
          />
        </>
      </div>
    </div>
  )
}
